import React from "react";
import { Container } from "react-bootstrap";
import ProfilePage from "./ProfilePage";
import "../css/Home.css";
import "../css/ComingSoon.css";
import { Helmet } from "react-helmet";
import { useAuth } from "./AuthContext";
import { useParams, useLocation } from "react-router-dom";
import { BsPlusCircleFill } from "react-icons/bs";

function Progress() {
  const video_row_4 =
    "https://t4abucket225336-staging.s3.us-east-2.amazonaws.com/videos_rope.mp4";

  const { username: routeUsername, levelId: routeLevelId } = useParams();
  const location = useLocation();
  const { user } = useAuth();

  const isAuthed = !!user;
  const isViewingOwnProfile =
    isAuthed && (!routeUsername || routeUsername === user?.username);

  const PlusBadge = () => (
    <span style={{ position: "relative", display: "inline-block", width: "1.05em", height: "1.05em", verticalAlign: "-0.15em", margin: "0 4px" }}>
      <BsPlusCircleFill style={{ position: "absolute", inset: 0, color: "black" }} />
      <BsPlusCircleFill style={{ position: "absolute", inset: 0, color: "white", transform: "scale(0.62)" }} />
    </span>
  );

  const subtitle = !isAuthed ? (
    <>
      <a className="home-link-join" href="/login">
        Join
      </a>{" "}
      to create your own profile and log progress
    </>
  ) : isViewingOwnProfile ? (
    <>
      Tap <PlusBadge /> in Best column to upload progress.
    </>
  ) : (
    <>
      To upload progress,{" "}
      <a className="home-link-join" href="/progress">go to your profile</a>.
    </>
  );

  return (
    <div className="page">
      <Helmet>
        <title>thenics4all</title>
        <meta
          name="description"
          content="Step-by-step Handstand pushup progressions, training and tutorials."
        />
        <meta
          name="keywords"
          content="handstand, handstand pushup, hspu, calisthenics, progression, tutorial"
        />
      </Helmet>

      <Container fluid>
        <div className="home-row">
          <video autoPlay loop muted playsInline className="home-row-video-background">
            <source src={video_row_4} type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          <h1>
            <a className="home-link" href="/progress">
              Progress
            </a>
          </h1>

          <h2 className="home-row-subtitle">{subtitle}</h2>

          <ProfilePage
            preselectedUsername={routeUsername || user?.username}
            externalUser={routeUsername || user?.username}
            externalLevelToOpen={routeLevelId}
            externalBestUrl={location.state?.externalBestUrl || null}
          />
        </div>
      </Container>
    </div>
  );
}

export default Progress;
